// extracted by mini-css-extract-plugin
module.exports = {"logoTicker":"logo-ticker_logoTicker___cGRh","logo":"logo-ticker_logo__nsXGl","logos":"logo-ticker_logos__2n1uk","slide-to-left":"logo-ticker_slide-to-left__k21ha"};